import createUniqueIdentifier from './createuniqueIdentifier'

const sumItems = (items) => {
    const itemsCounter = items.reduce((total, paint) => total + Number(paint.count), 0)

    let total = items.reduce((total, paint) => total + ((paint.price.price) * Number(paint.count)), 0)

    let total_price = itemsCounter * total

    return { itemsCounter, total, total_price }
}

const reducer = (state, action) => {
    switch (action.type) {
        case "UPDATE_CART":
            const { discount: oo, ...other } = state
            localStorage.setItem('cart', JSON.stringify({
                ...other,
                ...action.payload
            }))
            return {
                ...other,
                ...action.payload
            }
        case "ADD_ITEM": {
            const { size, min_width, max_width, min_height, max_height, title, artist, frame, price, id, mainImage, passpartout } = action.payload
            if (!frame.id) {
                alert('لطفا یک قاب برای تابلو انتخاب نمایید')
                return state
            }
            if ((parseInt(size.width) <= parseInt(max_width) && parseInt(size.width) >= parseInt(min_width)) && (parseInt(size.height) <= parseInt(max_height) && parseInt(size.height) >= parseInt(min_height))) {
                const uniqueId = createUniqueIdentifier(action.payload);
                if (!state.items.find(item => item.uniqueId === uniqueId)) {
                    state.items.push({
                        ...{ id, frame, price, size, artist, title, mainImage, passpartout },
                        uniqueId,
                        count: 1
                    })
                }
                localStorage.setItem('cart', JSON.stringify({
                    ...state,
                    items: [...state.items],
                    ...sumItems(state.items)
                }))
                return {
                    ...state,
                    items: [...state.items],
                    ...sumItems(state.items),
                    reload: Math.random()
                }
            } else {
                if (parseInt(size.width) < parseInt(max_width) && parseInt(size.width) > parseInt(min_width)) {
                    alert("ارتفاع " + `${min_height} <= (${size.height}) <= ${parseInt(max_height)}`)
                } else if (parseInt(size.height) < max_height && parseInt(size.height) > parseInt(min_height)) {
                    alert("عرض " + `${min_width} <= (${size.width}) <= ${max_width}`)
                }
            }
        }
        case "REMOVE_ITEM": {
            const uniqueId = createUniqueIdentifier(action.payload);
            const newitems = state.items.filter(i => i.uniqueId !== uniqueId)
            localStorage.setItem('cart', JSON.stringify({
                ...state,
                items: [...newitems],
                ...sumItems(newitems)
            }))
            return {
                ...state,
                items: [...newitems],
                ...sumItems(newitems),
                reload: Math.random()
            }
        }
        case "INCREASE": {
            const uniqueId = createUniqueIdentifier(action.payload);
            const Index = state.items.findIndex(i => i.uniqueId === uniqueId)
            let num = state.items[Index]
            num.count++
            localStorage.setItem('cart', JSON.stringify({
                ...state,
                ...sumItems(state.items)
            }))
            return {
                ...state,
                ...sumItems(state.items),
                reload: Math.random()
            }
        }
        case "DECREASE": {
            const uniqueId = createUniqueIdentifier(action.payload);
            const Index2 = state.items.findIndex(i => i.uniqueId === uniqueId)
            state.items[Index2].count--
            localStorage.setItem('cart', JSON.stringify({
                ...state,
                ...sumItems(state.items)
            }))
            return {
                ...state,
                ...sumItems(state.items),
                reload: Math.random()
            }
        }
        case "ADD_ADDRESS": {
            localStorage.setItem('cart', JSON.stringify({ ...state, address: action.payload }))
            return { ...state, address: action.payload }
        }
        case "CLEAR": {
            localStorage.setItem('cart', JSON.stringify({
                items: [],
                itemsCounter: 0,
                total: 0,
                total_price: 0,
                address: {},
            }))
            return {
                items: [],
                itemsCounter: 0,
                total: 0,
                total_price: 0,
                address: {},
            }
        }
        case "INIT_STORED_CART":
            return action.payload
        default:
            return state
    }
}

export default reducer